import { SearchInput } from '@/components/Form';
import { PendoPlaceholder } from '@/components/PendoPlaceholder';

type Props = {
  search: string;
  onSearchChange: (search: string) => void;
};

const IntegrationsListActions = ({ search, onSearchChange }: Props) => {
  return (
    <div className="flex items-center gap-2">
      <PendoPlaceholder />
      <SearchInput value={search} onValueChange={onSearchChange} debounceTime={250} />
    </div>
  );
};

export default IntegrationsListActions;
